// Drives the export status card (transactions/shared/_export_status_card) on the transactions and events pages.
const POLL_INTERVAL_MS = 5000;
const POLL_REQUEST_TIMEOUT_MS = 15000;
const MAX_POLL_ATTEMPTS = 30;

document.addEventListener("DOMContentLoaded", () => {
  const base = document.getElementById("csv-base");
  if (!base) return;

  const { exportStatus, statusUrl, downloadUrl } = base.dataset;
  if (!statusUrl) return;

  const resetCssStatuses = () => {
    $("#csv-base").removeClass("pending completed error");
    $(".category-csv-pending, .category-csv-completed, .category-csv-error").addClass("visually-hidden");
  };

  const setError = () => {
    resetCssStatuses();
    $("#csv-base").addClass("error");
    $(".category-csv-error").removeClass("visually-hidden");
  };

  const setPending = () => {
    resetCssStatuses();
    $("#csv-base").addClass("pending");
    $(".category-csv-pending").removeClass("visually-hidden");
  };

  const setCompleted = () => {
    resetCssStatuses();
    $("#csv-base").addClass("completed");
    $(".category-csv-completed").removeClass("visually-hidden");
    $("#csv-button-completed").attr("href", downloadUrl || "");
  };

  // Schedules the next poll only once the previous request has finished, so slow
  // status requests can't overlap and resolve out of order. Gives up with the error
  // state once MAX_POLL_ATTEMPTS is reached rather than leaving the card on "Processing".
  const pollExportStatus = (attempt = 1) => {
    if (attempt > MAX_POLL_ATTEMPTS) {
      setError();
      return;
    }

    setTimeout(() => {
      $.ajax({ url: statusUrl, dataType: "json", timeout: POLL_REQUEST_TIMEOUT_MS })
        .done((res) => {
          if (!res.status || res.status === "error") {
            setError();
          } else if (res.status === "completed") {
            setCompleted();
          } else {
            // pending or an in-progress step (querying, writing, uploading, ...)
            pollExportStatus(attempt + 1);
          }
        })
        .fail((_xhr, textStatus) => {
          // A single slow request counts as an attempt; anything else is a real failure.
          if (textStatus === "timeout") {
            pollExportStatus(attempt + 1);
          } else {
            setError();
          }
        });
    }, POLL_INTERVAL_MS);
  };

  if (exportStatus === "completed") {
    setCompleted();
  } else if (exportStatus === "error") {
    setError();
  } else {
    setPending();
    pollExportStatus();
  }
});
